// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WrapperWithBackButton_wrapper__zK9YJ","extraTopPadding":"WrapperWithBackButton_extraTopPadding__7nW6X"};